import { useField } from 'formik';
import MaterialTextField, { TextFieldProps as MaterialTextFieldProps } from '@mui/material/TextField';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  field: {
    margin: theme.spacing(1, 0),
  }
}));

type Props = {
  name: string;
  label?: string;
  disabled?: boolean;
  touched?: boolean;
  errorsDisabled?: boolean;
  helperText?: React.ReactNode;
  className?: string;
} & Omit<MaterialTextFieldProps, 'name' | 'label' | 'disabled' | 'helperText' | 'className'>;

const TextAreaField = (props: Props) => {
  const {
    name,
    label,
    disabled,
    errorsDisabled = false,
    helperText,
    touched: formTouched,
    className,
    ...rest
  } = props;
  const { classes, cx } = useStyles();
  const [field, meta] = useField(name);
  const touched = formTouched || meta.touched;
  const currentError = meta.error;

  return (
    <MaterialTextField
      id={name}
      label={label}
      {...field}
      value={field.value || ''}
      error={!errorsDisabled && touched && Boolean(currentError)}
      helperText={(!errorsDisabled && touched && currentError) || helperText}
      fullWidth
      multiline
      minRows={2}
      maxRows={20}
      disabled={disabled}
      variant="outlined"
      className={cx(classes.field, className)}
      {...rest}
    />
  );
};

export default TextAreaField;
